module.exports = __webpack_public_path__ + "static/img/ia_100000004.d4017134.png";